import { Switch, Route } from "react-router-dom";
import Login from "../components/login/Login";
import Register from "../components/register/Register";
import Users from "../components/ManagerUsers/Users";
import Home from "../components/home/Home";
import CreateApp from "../components/CreateApp/CreateApp";
import EditApp from "../components/editApp";
import PushNotification from "../components/pushNotification";
import PushSchedule from "../components/pushSchedule";
import AppConfig from "../components/appConfig";
import About from "../components/about";
import PrivateRoutes from "./PrivateRoutes";
const AppRoutes = (props) => {
  return (
    <>
      <Switch>
        <Route path="/login" component={Login} />

        <PrivateRoutes path="/admin" component={Home} exact />
        <PrivateRoutes path="/register" component={Register} />
        <PrivateRoutes path="/users" component={Users} />
        <PrivateRoutes path="/createApp" component={CreateApp} />
        <PrivateRoutes path="/editApp" component={EditApp} />
        <PrivateRoutes path="/push" component={PushNotification} />
        <PrivateRoutes path="/push-schedule" component={PushSchedule} />
        <PrivateRoutes path="/app-config" component={AppConfig} />
        <PrivateRoutes path="/about" component={About} exact />

        <Route path="*">404 Not found</Route>
      </Switch>
    </>
  );
};
export default AppRoutes;
